import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/6960b14c7683ed001472e800/ativanam_solutions/src/app/services-overview/components/ServicesInteractive.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/6960b14c7683ed001472e800/ativanam_solutions/src/components/common/Header.tsx");
